//リロード時にページ先頭に行くように
// window.onbeforeunload = function () {

// }

function buttonClick(variantId){
  let formData = {
    items: [
      {
        id: variantId,
        quantity: 1,
      },
    ],
  };

  (async function () {
    await fetch("/cart/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
    .catch((error) => {
      console.error("Error:", error)
    });

    location.reload();
    //リロード時にページ先頭に行くように
    window.scrollTo(0, 0);

  })();
}